var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.a9dc26a008fe1538450500f75ada6a0e.svg#l';
                    var viewUrl = 'sprites.a9dc26a008fe1538450500f75ada6a0e.svg#view-l';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 87 28',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };